module.exports = __webpack_public_path__ + "img/fizteh.30904ac3.png";